require('../../modules/es6.string.iterator');
require('../../modules/web.dom.iterable');
module.exports = require('../../modules/_wks-ext').f('iterator');



//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/core-js/library/fn/symbol/iterator.js
// module id = 961
// module chunks = 48 49 50